import { render, staticRenderFns } from "./TagRich.vue?vue&type=template&id=f6fb0950&scoped=true&"
import script from "./TagRich.vue?vue&type=script&lang=js&"
export * from "./TagRich.vue?vue&type=script&lang=js&"
import style0 from "./TagRich.vue?vue&type=style&index=0&id=f6fb0950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fb0950",
  null
  
)

export default component.exports